export default "__VITE_ASSET__2b2d3552__"